/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { HomeActionTypes } from '../actions/home';
import { CustomAction } from '../actions/CustomAction';

export interface HomeState {
    loading: boolean,
    user: Object,
    token: Object,
    error: Object
}

const initialHomeState: HomeState = {
    loading: false,
    user: {},
    token: {},
    error: null
};

export function reducer(state = initialHomeState, action: CustomAction): HomeState {
    switch (action.type) {
        case HomeActionTypes.HOME_GET_TOKEN:
            return Object.assign({}, state, {
                loading: true,
                token: initialHomeState.token
            });

        case HomeActionTypes.HOME_TOKEN_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                token: action.payload,
                error: null
            });

        case HomeActionTypes.HOME_TOKEN_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                token: {},
                error: action.payload
            });

        case HomeActionTypes.HOME_GET_USERDATA:
            return Object.assign({}, state, {
                loading: true,
                user: initialHomeState.user
            });

        case HomeActionTypes.HOME_USERDATA_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                user: action.payload,
                error: null
            });

        case HomeActionTypes.HOME_USERDATA_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                user: {},
                error: action.payload
            });

        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */
export function isLoading(state: HomeState) {
    return state.loading;
}

export function getUser(state: HomeState) {
    return state.user;
}

export function getError(state: HomeState) {
    return state.error;
}

export function getToken(state: HomeState) {
    return state.token;
}
